<div #creation_container data-testid="creation_container" class="container-popup">
  <div class="ui-g-12 p-0">
    <h2>{{ 'campaign.header' | translate }} <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">
    <app-form-fields #campaign_name data-testid="campaign_name" [(fieldModel)]="newFieldModel.campaign_name"
      [type]="'string'" [name]="'campaign_name'" [optionLabel]="'name'"
      [placeholder]="'campaign.campaign_name_placeholder' | translate" [required]="true"
      [label]="'campaign.campaign_name' | translate"></app-form-fields>

  </div>

  <div class="ui-g-12 p-0">
    <app-form-fields #campaign_description data-testid="campaign_description"
      [(fieldModel)]="newFieldModel.campaign_description" [type]="'textarea'" [name]="'campaign_description'"
      [optionLabel]="'description'" [placeholder]="'campaign.campaign_description_placeholder' | translate"
      [required]="true" [label]="'campaign.campaign_description' | translate"></app-form-fields>

  </div>

  <div class="ui-g-12 p-0 mt2">
    <h2 class="title-margin">{{ 'campaign.campaign_validity_period' | translate }} <i class="pi pi-info-circle"></i>
    </h2>
  </div>

  <div class="ui-g-12 p-0">
    <div class="ui-g-6"
      *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
      <app-form-fields #start_date data-testid="start_date" [showRequiredAsterix]="false"
        [label]="'campaign.start_date' | translate" [(fieldModel)]="newFieldModel.start_date" [type]="'date'"
        [required]="true" [placeholder]="'campaign.select_start_date' | translate"></app-form-fields>

    </div>
    <div class="ui-g-6"
      *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
      <app-form-fields #end_date data-testid="end_date" [showRequiredAsterix]="false"
        [label]="'campaign.end_date' | translate" [(fieldModel)]="newFieldModel.end_date" [type]="'date'"
        [required]="true" [placeholder]="'campaign.select_end_date' | translate"></app-form-fields>

    </div>
  </div>

  <div class="ui-g-12 p-0">
    <h2 class="title-margin">{{ 'campaign.type' | translate }}<span class="mandatory">*</span></h2>
  </div>

  <div class="ui-g-12 p-0">
    <div class="ui-g-6">
      <app-form-fields #campaign_type data-testid="campaign_type" [(fieldModel)]="newFieldModel.campaign_type"
        [type]="'dropdown'" [options]="campaignTypeList" [name]="'campaign_type'" [optionLabel]="'label'"
        [placeholder]="'campaign.select_campaign_type' | translate" [required]="true"
        [label]="'campaign.campaign_type' | translate">
      </app-form-fields>

    </div>

    <div class="ui-g-6 d-flex justify-content-center align-items-center flex-column">
      <h2 for="status">{{ 'campaign.status' | translate }}</h2>

      <span>{{ 'campaign.in_creation' | translate }}</span>

    </div>

  </div>

  <div class="ui-g-12 p-0 mt2">
    <h2 class="title-margin">{{ 'campaign.campaign_budget' | translate }} <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">
    <div class="ui-g-6" style="padding-top: 11px;">
      <app-form-fields #budget_type data-testid="budget_type" [(fieldModel)]="newFieldModel.budget_type"
        [type]="'dropdown'" [placeholder]="'campaign.select_budget_type' | translate" [options]="budgetTypeList"
        [name]="'budget_type'" [optionLabel]="'label'" [label]="'campaign.budget_type' | translate"
        [required]="true"></app-form-fields>

    </div>
    <div class="ui-g-6" style="margin-top: 4px;">
      <!-- Mostrare il tipo di valuta, non penso rimanga int -->
      <app-form-fields #budget_value data-testid="budget_value" [(fieldModel)]="newFieldModel.budget_value"
        [name]="'budget_value'" [step]="100" [label]="'campaign.budget_value' | translate" [type]="'number'"
        [placeholder]="'campaign.budget_placeholder' | translate" [required]="true"></app-form-fields>

    </div>
  </div>


  <div class="ui-g-12  d-flex justify-content-center edit-btn-container">
    <button class="btn-edit-footer" data-testid="common_cancel" (click)="onClosePopup()">{{'common.cancel' |
      translate}}</button>
    <button class="btn-edit-footer" data-testid="common_save" (click)="OnSaveEntity()">{{'common.save' |
      translate}}</button>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/new-campaign-3/new-campaign-3.component.html